<template>
    <WtcAccordion
        class="odd:bg-surface even:bg-surface-alternate border-b-0 px-2"
        :expand-on-click="false"
        :expanded="expanded"
        :icon="faChevronDown"
        :icon-expanded="faChevronUp"
        :on-header-click="handleAccordionClick"
    >
        <template #title>
            <div class="flex gap-3">
                <div class="flex items-center justify-start">
                    <div>
                        <img v-if="discipline?.IsDiamondRace" class="mr-4 h-4 w-5" src="../assets/images/diamond.svg" />
                    </div>
                    <span>{{ translatedDisciplineName }}</span>
                </div>
            </div>
        </template>
        <template #content>
            <div class="my-3 flex gap-2">
                <WtcButton class="!text-brand-secondary" @click.stop="toggleResultContent">{{
                    getStrByLng().LABEL_RESULTS
                }}</WtcButton>
                <WtcButton
                    v-if="discipline && disciplineRecords?.length > 0"
                    class="!text-brand-secondary"
                    @click.stop="toggleRecordContent"
                    >{{ getStrByLng().LABEL_RECORDS }}</WtcButton
                >
            </div>
            <DisciplineItemResults v-if="contentType === 'result'" :units-dictionary="discipline?.Data" />
            <DisciplineItemRecords v-if="contentType === 'record'" :records="disciplineRecords" />
        </template>
    </WtcAccordion>
</template>

<script setup lang="ts">
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useTranslatedProperty } from "@swisstiming/owl-core";
import { getStrByLng, WtcAccordion, WtcButton } from "@swisstiming/webtec-kit";
import { computed, ref } from "vue";

import { IEventData, IInfo } from "../interfaces/wdl-archive.interfaces";
import DisciplineItemRecords from "./DisciplineItemRecords.vue";
import DisciplineItemResults from "./DisciplineItemResults.vue";

const props = withDefaults(
    defineProps<{
        discipline?: IEventData;
    }>(),
    {}
);
const expanded = ref(false);
const contentType = ref<"result" | "record">("result");

const handleAccordionClick = () => {
    if (expanded.value) {
        expanded.value = false;
    } else {
        contentType.value = "result";
        expanded.value = true;
    }
};
const toggleResultContent = () => {
    if (contentType.value === "record") {
        expanded.value = true;
    } else {
        expanded.value = !expanded.value;
    }
    contentType.value = "result";
};
const toggleRecordContent = () => {
    if (contentType.value === "result") {
        expanded.value = true;
    } else {
        expanded.value = !expanded.value;
    }
    contentType.value = "record";
};

// translation for disciplines (event-names) are only available on the unit
// try to get the event-name translations of the first unit otherwise use the default
const translatedDisciplineName = computed(
    () =>
        useTranslatedProperty<IInfo>(
            Object.values(props.discipline?.Data ?? {})?.at(0)?.Info,
            "Event_Name",
            "Event_Names"
        ) ?? props.discipline.Name
);

// records (wr, ar, etc.) are only available on a unit and there can be multiple units in an event
// since there are no event-records the records of the first unit with records is displayed
const disciplineRecords = computed(
    () => Object.values(props.discipline?.Data ?? {})?.find((unit) => unit?.Records?.length > 0)?.Records
);
</script>
